"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refundFactory = void 0;
const Factory = require("factory.ts");
const mocks_1 = require("../../../mocks");
exports.refundFactory = Factory.Sync.makeFactory({
    id: Factory.each(i => i + 1),
    tenant_id: Factory.each(i => i + 1),
    tenant_type: 'tenant_type',
    source_system: 'source_system',
    source_system_id: Factory.each(i => i + 1),
    department: 'department',
    originator: 'originator',
    originator_name: 'originator_name',
    sale_date: mocks_1.dates.date2000,
    sale_id: Factory.each(i => i + 1),
    sale_type: 'Invoice',
    sale_number: 'sale_number',
    gross_amount_cents: 1000,
    fee_cents: 100,
    refund_amount_cents: 900,
    refund_transaction_id: Factory.each(i => i + 1),
    refund_date: mocks_1.dates.date2100,
    refund_type: 'cash',
    refund_payout_id: Factory.each(i => i + 1),
    refund_payout_date: mocks_1.dates.date2100,
    original_transaction_id: Factory.each(i => i + 1),
    original_transaction_payout_id: Factory.each(i => i + 1),
    original_transaction_payout_date: 'original_transaction_payout_date',
    issuer: 'issuer',
    notes: 'notes',
    account_owner_first_name: 'first_name',
    account_owner_last_name: 'last_name',
    account_owner_id: Factory.each(i => i + 1),
    participant_id: Factory.each(i => i + 1),
    participant_name: 'participant_name',
    refund_date_formatted: '10/08/2021 02:29 PM',
    refund_amount_formatted: '$2.00',
    refund_type_formatted: 'Full',
    account_owner_name_formatted: 'Test Owner',
    sale_date_formatted: 'Jan 12, 2021,  4:23 PM UTC',
    gross_amount_formatted: '$2.99',
    fee_formatted: '$0.99',
    original_transaction_payout_date_formatted: 'Jan 18, 2021',
    refund_payout_date_formatted: 'Jun 27, 2022',
});
